const TOKEN_KEY = '_q_t'
const USERID_KEY = '_q_u'
const USERNAME_KEY = '_q_u_n'
const OPENID_KEY = '_q_o'
const PHONE_KEY = '_q_p'
const INFO_KEY = '_m_i'
const DETAIL_KEY = '_q_d'
const PRINT_KEY = '_q_print'
const PORTRAIT_KEY = '_q_p_r'
//订单暂存
const STAG_ORDER_KEY = '_q_s_o_k'

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY)
}

export const setToken = token => {
  localStorage.setItem(TOKEN_KEY, token)
}

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY)
}

export const getUserId = () => {
  return localStorage.getItem(USERID_KEY)
}

export const setUserId = userId => {
  localStorage.setItem(USERID_KEY, userId)
}

export const getUserName = () => {
  return localStorage.getItem(USERNAME_KEY)
}

export const setUserName = userName => {
  localStorage.setItem(USERNAME_KEY, userName)
}

export const getPortrait = () => {
  return localStorage.getItem(PORTRAIT_KEY)
}

export const setPortrait = portrait => {
  localStorage.setItem(PORTRAIT_KEY, portrait)
}

export const getOpenId = () => {
  return localStorage.getItem(OPENID_KEY)
}

export const setOpenId = openId => {
  localStorage.setItem(OPENID_KEY, openId)
}

export const getPhone = (encryption = false) => {
  const phone = localStorage.getItem(PHONE_KEY)
  if (phone) {
    if (encryption) {
      return phone.substring(0, 4) + '****' + phone.substring(8, 11)
    }
    return phone
  }
  return undefined
}

export const getPhoneKey = () => {
  return localStorage.getItem(PHONE_KEY)
}

export const setPhone = phone => {
  localStorage.setItem(PHONE_KEY, phone)
}

export const getAdminInfo = () => {
  return localStorage.getItem(INFO_KEY)
    ? JSON.parse(localStorage.getItem(INFO_KEY))
    : ''
}

export const setAdminInfo = info => {
  localStorage.setItem(INFO_KEY, info ? JSON.stringify(info) : '')
}

export const removeAdminInfo = () => {
  localStorage.removeItem(INFO_KEY)
}

export const getDetail = () => {
  return localStorage.getItem(DETAIL_KEY)
}

export const setDetail = detail => {
  localStorage.setItem(DETAIL_KEY, detail)
}

export const getPrintDetail = () => {
  return localStorage.getItem(PRINT_KEY)
}

export const setPrintDetail = print => {
  localStorage.setItem(PRINT_KEY, print)
}

//

export const getStagOrder = () => {
  return localStorage.getItem(STAG_ORDER_KEY)
}

export const setStagOrder = order => {
  localStorage.setItem(STAG_ORDER_KEY, order)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js